import React, { Component } from 'react'
import { Link } from 'react-router-dom';

const Header = (props) => {
    return (
        <div className="nav-bar">
        <ul>
          <li>
            <Link to="/">Deja</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            {/* <Link to="/examples/reddit">Reddit API Demo</Link> */}
            <Link to="/partners">Partners</Link>
          </li>
          {/* <li>
            <Link to="/">Back to start page</Link>
          </li> */}
        </ul>
      </div>
    )
}
export default class Layout extends Component {
    render () {
        return (
            <div>
                <Header />
                <div className="home-content-container">
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/features/homepage/layout.js